import styled from 'styled-components';

export const SecurityRankFieldStyles = styled.div`
	display: flex;
	align-items: center;
	gap: 0.4rem;

	&.container {
		height: 2.5rem;
		margin-top: 0.25rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		padding: 0 0.5rem;
		background: ${({ theme }) => theme.v3.colors.gray[2]};
	}

	.rank-total {
		white-space: nowrap;
	}

	.cta {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		margin-left: auto;
		padding-left: 0.5rem;
		white-space: nowrap;
	}

	.arrow {
		border-radius: 2px;
		padding: 2px;
	}

	&.clickable {
		cursor: pointer;

		&:hover {
			.rank-name,
			.cta-label {
				color: ${({ theme }) => theme.v3.colors.blue[6]};
				text-decoration: underline;
			}
		}
	}
`;
